import { Model, View } from '@lernetz/ts-lib';
import { context } from '@lernetz/ts-lib/src/view/Template';

import template from './Paragraph.html';


export class Paragraph extends Model {

    public readonly color: string;
    public readonly id: string;
    public readonly marginTop: string;
    public readonly marginBottom: string;
    public readonly style: string;

    private readonly modelName: string;
    private readonly originalText_: string;
    private text_: string;

    constructor(dto) {
        super();
        this.color = dto.color || '-blue-page';
        this.id = dto.hash || dto.id;
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';
        this.style = dto.style || '-p';

        this.modelName = dto.modelName;
        this.originalText_ = dto.text || '';
    }

    get isLead(): boolean {
        return this.isParagraph && this.style !== '-p';
    }

    get isParagraph(): boolean {
        return this.modelName === 'App\\Paragraph';
    }

    get text(): string {
        if (!this.text_) {
            this.text_ = this.originalText_.replace(new RegExp('app://download/([0-9A-Fa-f]+)', 'g'), context.downloadPath('$1'));
        }
        return this.text_;
    }
}


export class ParagraphView extends View<Paragraph> {

    constructor() {
        super({ template });
    }

    init() {
        this.node.innerHTML = this.data.text;
        addContentItemAndTextStyleVariants(this.node);
    }
}


/**
 * Adds suitable `content-item` and `text-style` variant CSS classes to all child elements of the given DOM node.
 */
export function addContentItemAndTextStyleVariants(root: Node): void {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    while (walker.nextNode()) {
        const node = <Element> walker.currentNode;
        node.classList.add('text-style');
        switch (node.localName) {
            case 'a':
                node.classList.add('-link');
                break;
            case 'b':
                node.classList.add('-bold');
                break;
            case 'i':
                node.classList.add('-em');
                break;
            case 'li':
                node.classList.add('-para', 'content-element', '-list-item');
                break;
            case 'ol':
            case 'ul':
                node.classList.add('-list', 'content-element', '-list', 'list-style', '-default', 'content-element-layout');
                break;
            case 'p':
                node.classList.add('-para', 'content-element', '-para');
                break;
            case 'sub':
                node.classList.add('-sub');
                break;
            case 'sup':
                node.classList.add('-sup');
                break;
            }

    }
}
